import React, { useEffect, useState, useRef, Fragment } from "react";
import { Link } from "react-router-dom";
import { any, string, func, object, array } from "prop-types";
import * as style from "./styles.module.scss";
import PulseLoader from "../../common/PulseLoader";

export const FormShortcutStatus = Object.freeze({
  Todo: 1,
  Done: 2,
});

export const FormShortcut = ({
  status = FormShortcut.Todo,
  text,
  link = "",
  formCode,
  getPdf,
  pdfObject,
}) => {
  const [downloading, setDownloading] = useState();
  const downloadRef = useRef();
  const hasPdf = pdfObject.length > 0 && pdfObject[0].pdfString;
  useEffect(() => {
    if (
      pdfObject.length > 0 &&
      downloading &&
      pdfObject[0].pdfString &&
      !pdfObject[0].isDownloading
    ) {
      // eslint-disable-next-line
      const blob = new Blob([pdfObject[0].pdfString], {
        type: "application/pdf",
      });
      downloadRef.current.href = window.URL.createObjectURL(blob);
      downloadRef.current.download = `${text}.pdf`;
      downloadRef.current.click();
      setDownloading(false);
    }
  }, [pdfObject]);

  const handlePdfDownloadClick = () => {
    if (!hasPdf) getPdf(formCode);
    setDownloading(true);
  };

  return (
    <div className={`${style.onlineForms__wrapper}`}>
      <div className={`${style.onlineForms__mobile_row}`}>
        <div
          className={`${style.onlineForms__status} ${
            status === FormShortcutStatus.Todo
              ? style.onlineForms__todo
              : style.onlineForms__done
          }
        `}
        >
          {status === FormShortcutStatus.Todo ? "To Do" : "Done"}
        </div>
        <span className={`${style.onlineForms__title}`}>{text}</span>
      </div>
      {status === FormShortcutStatus.Todo ? (
        <Link
          to={link}
          className={`${style.onlineForms__button} ${style.onlineForms__download} btn btn-md btn-outline`}
        >
          Enter Details
        </Link>
      ) : (
        <a
          className={`${style.onlineForms__button} ${style.onlineForms__download} btn btn-md btn-outline`}
          onClick={handlePdfDownloadClick}
          ref={downloadRef}
        >
          {pdfObject[0] && pdfObject[0].isDownloading ? (
            <PulseLoader isSmall />
          ) : (
            "View Details"
          )}
        </a>
      )}
    </div>
  );
};

FormShortcut.propTypes = {
  status: any,
  text: string,
  link: string,
  formCode: string,
  getPdf: func,
  pdfObject: object,
};

const OnlineForms = ({ getPdf, reflexAllenForms, reflexAllenOnboarding }) => {
  const regulationsForm =
    reflexAllenForms &&
    reflexAllenForms.filter((elem) => elem.formCode === "regulations-form");
  const regulationsExistInUserData =
    reflexAllenOnboarding.onlineForms &&
    reflexAllenOnboarding.onlineForms.includes("regulations-form");
  const nightWorkersForm =
    reflexAllenForms &&
    reflexAllenForms.filter(
      (elem) => elem.formCode === "night-workers-health-questionnaire"
    );
  const nightWorkerrsExistInUserData =
    reflexAllenOnboarding.onlineForms &&
    reflexAllenOnboarding.onlineForms.includes(
      "night-workers-health-questionnaire"
    );
  const formsToShow = [
    <FormShortcut
      key={"regulations-form"}
      status={
        regulationsForm.length > 0 || regulationsExistInUserData
          ? FormShortcutStatus.Done
          : FormShortcutStatus.Todo
      }
      text={"Working Time Regulations Opt Out Agreement"}
      link={"/profile/edit/onboarding/regulations"}
      formCode={"regulations-form"}
      pdfObject={regulationsForm}
      getPdf={getPdf}
    />,
    <FormShortcut
      key={"night-workers-health-questionnaire"}
      status={
        nightWorkersForm.length > 0 || nightWorkerrsExistInUserData
          ? FormShortcutStatus.Done
          : FormShortcutStatus.Todo
      }
      text={"Night Workers Health Questionnaire"}
      link={"/profile/edit/onboarding/night-workers-questionnaire"}
      formCode={"night-workers-health-questionnaire"}
      pdfObject={nightWorkersForm}
      getPdf={getPdf}
    />,
  ];

  return (
    <Fragment>
      {formsToShow
        .sort((prevForm) => {
          return prevForm.props.status === FormShortcutStatus.Done ? 1 : -1;
        })
        .map((form) => form)}
    </Fragment>
  );
};

OnlineForms.propTypes = {
  getPdf: func,
  reflexAllenForms: array,
  reflexAllenOnboarding: object,
};

export default OnlineForms;
